<template>
    <div class="box">
        <div style="display: flex;flex-direction: column;width: 100%;height: 600px;" v-if="mShow == 1">
            <h2>设备管理平台</h2>
            <p>管理公司所有产品、设备，实现设备监测信息化流程。</p>

            <a href="http://114.115.219.204/">
                <el-button type="primary">立即体验</el-button>
            </a>
        </div>

        <div style="display: flex;flex-direction: column;width: 100%;height: 600px;" v-if="mShow == 2">
            <h2>抄表营收系统</h2>
            <p>实现以档案、抄表、账号、收费、报表、通知、阀门的一体化智能营业系统。</p>

            <a href="http://114.115.162.140:9960/">
                <el-button type="primary">立即体验</el-button>
            </a>
        </div>

        <div style="display: flex;flex-direction: column;width: 100%;height: 600px;" v-if="mShow == 3">
            <h2>水务运维平台</h2>
            <p>监测设备压力、电池电压、信号等信息，并进行设备更改。</p>

            <a href="http://www.kedaxk.com/wdywgj13/">
                <el-button type="primary">立即体验</el-button>
            </a>
        </div>

        <div style="display: flex;flex-direction: column;width: 100%;height: 600px;" v-if="mShow == 4">
            <h2>集抄协同服务平台</h2>
            <p>实现多厂家计量设备的数据接入，为客户提供统一的设备和计量数据管理。</p>

            <a href="http://114.115.162.140:8099/water/login.jsp">
                <el-button type="primary">立即体验</el-button>
            </a>
        </div>

        <div style="display: flex;flex-direction: column;width: 100%;height: 600px;" v-if="mShow == 5">
            <h2>物联网装备云平台</h2>
            <p>实现终端设备、项目、触发器的管理平台。</p>

            <a href="http://114.115.247.229/user/index">
                <el-button type="primary">立即体验</el-button>
            </a>
        </div>

        <div style="display: flex;flex-direction: column;width: 100%;height: 600px;" v-if="mShow == 6">
            <h2>智慧水务云平台</h2>
            <p>展示水源地、水厂、加压泵站、水质监测、安防监控、集抄、管网监测等信息。</p>

            <a href="http://www.kedaxk.com:8003/Home/Login">
                <el-button type="primary">立即体验</el-button>
            </a>
        </div>

        <div style="display: flex;flex-direction: column;width: 100%;height: 600px;" v-if="mShow == 7">
            <h2>智慧水厂可视化平台</h2>
            <p>以数字孪生与BIM实现的智慧水厂可视化平台。</p>

            <a href="http://keda.ilab-vr.com/">
                <el-button type="primary">立即体验</el-button>
            </a>
        </div>

        <div style="display: flex;flex-direction: column;width: 100%;height: 600px;" v-if="mShow == 8">
            <h2>分区计量系统</h2>
            <p>为客户提供快速、精准、低成本、可持续的分区控漏方案。</p>

            <a href="http://114.115.162.140:9969">
                <el-button type="primary">立即体验</el-button>
            </a>
        </div>

        <div style="display: flex;flex-direction: column;width: 100%;height: 600px;" v-if="mShow == 9">
            <h2>智慧养老</h2>
            <p>集数据采集、管理与跟踪、监护与报警、紧急呼救为一体智能化养老方案。</p>

            <a href="http://114.115.162.140:9968">
                <el-button type="primary">立即体验</el-button>
            </a>
        </div>
    </div>
</template>
  
<script>
export default {
    name: 'ProductDetail',
    data() {
        return {
            mShow: undefined
        }
    }
    ,
    created() {
        this.mShow = this.$route.params && this.$route.params.id;
    },
    watch: {
        $route: function (to, from) {
            this.mShow = this.$route.params && this.$route.params.id;
            // console.log("==========ss", this.$route.params && this.$route.params.id)
        },
    }
}
</script>
  
<style scoped type="text/less" lang="less">
.box {
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 75vh;
}

.bg-img-one {
    width: 100%;
    height: 1600px;
    background: url(../assets/img/product-01.jpg) no-repeat center center;
    background-size: 80%;
}

.bg-img-two {
    width: 100%;
    height: 1300px;
    background: url(../assets/img/product-02.jpg) no-repeat center center;
    background-size: 80%;
}
</style>
  